import { render, staticRenderFns } from "./BillingVirtualAccountBNI.vue?vue&type=template&id=4fa8a5da"
import script from "./BillingVirtualAccountBNI.vue?vue&type=script&lang=js"
export * from "./BillingVirtualAccountBNI.vue?vue&type=script&lang=js"
import style0 from "./BillingVirtualAccountBNI.vue?vue&type=style&index=0&id=4fa8a5da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports